import { useCallback } from 'react';

import { useToggleOnAir } from '@/scenarios/legacy-player/hooks/useToggleOnAir';
import { PlayingState } from '@/scenarios/legacy-player/types/instance';

import { useUserActionIndicatorChangers } from './use-user-action-indicator';

export const useToggleOnAirWithIndicator = (): {
    returnToAir: () => void;
    pause: () => void;
    toggleOnAir: () => PlayingState.play | PlayingState.pause | undefined;
} => {
    const { toggleOnAir, returnToAir, pause } = useToggleOnAir();
    const { showPlay, showPause } = useUserActionIndicatorChangers();

    const toggleOnAirWithIndicator = useCallback(() => {
        const targetPlayingState = toggleOnAir();

        if (targetPlayingState === PlayingState.play) {
            showPlay();
        }

        if (targetPlayingState === PlayingState.pause) {
            showPause();
        }

        return targetPlayingState;
    }, [toggleOnAir, showPause, showPlay]);

    const returnToAirWithIndicator = useCallback(() => {
        returnToAir();
    }, [returnToAir]);

    const pauseWithIndicator = useCallback(() => {
        pause();
        showPause();
    }, [pause, showPause]);

    return {
        returnToAir: returnToAirWithIndicator,
        toggleOnAir: toggleOnAirWithIndicator,
        pause: pauseWithIndicator,
    };
};
